import { css, cx } from 'emotion';

import { headingSmall, aqua } from 'inside-out/global-styles';

import FileIcon from 'inside-out/images/support-organisations/file-icon.svg';

export const titleStyle = cx(
	headingSmall,
	css({
		marginBottom: '12px',
	})
);

export const listStyle = css({
	margin: '0',
	padding: '0',
	'& li': {
		display: 'inline-block',
		listsStyle: 'none',
		padding: '0',
		'& a': {
			display: 'block',
			background: aqua,
			borderRadius: '4px',
			color: '#fff',
			padding: '13px 13px 13px 43px',
			fontSize: '16px',
			lineHeight: '22px',
			position: 'relative',
			maxWidth: '289px',
			width: '100%',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			textDecoration: 'none',
			'&:after': {
				position: 'absolute',
				top: '13px',
				left: '13px',
				display: 'block',
				width: '24px',
				height: '24px',
				content: '" "',
				backgroundRepeat: 'no-repeat',
				backgroundImage: `url(${FileIcon})`,
			},
		},
		'&:not(:last-child)': {
			marginRight: '12px',
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/fileAttachments/styles.js